import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { dashboardApi } from '@/services/dashboardApi';

export default function DashboardForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      setSent(await dashboardApi.forgotPassword(email.trim()));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060d1b] flex items-center justify-center px-4">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block mb-6" aria-label="Volver a la web de Freedom Homes Club">
            <img src="/logo-fhc-sm.png" alt="Freedom Homes Club" className="h-16 w-auto mx-auto" />
          </Link>
          <h1 className="text-2xl font-bold text-white mb-2 tracking-tight">Recupera tu acceso</h1>
          <p className="text-gray-400 text-sm">Te enviaremos un enlace para crear una contraseña nueva.</p>
        </div>

        <div className="bg-white/[0.02] border border-white/[0.06] rounded-2xl p-8" data-testid="forgot-card">
          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-sent">
              <CheckCircle2 size={36} className="text-emerald-400 mx-auto" />
              <p className="text-sm text-gray-300 leading-relaxed">{sent.message}</p>
              {sent.dev_link && (
                <p className="text-xs text-amber-300/90 break-all">
                  Entorno de pruebas sin email configurado: <a href={sent.dev_link} className="underline">abrir enlace</a>
                </p>
              )}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="forgot-email" className="block text-[11px] text-gray-400 uppercase tracking-wider font-medium mb-2">Email de tu cuenta</label>
                <input
                  id="forgot-email" type="email" required autoComplete="email" value={email} disabled={loading}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-white/[0.03] border border-white/[0.08] rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-[#c9a84c]/40 disabled:opacity-50 placeholder:text-gray-600"
                  placeholder="tu@email.com" data-testid="forgot-email"
                />
              </div>
              {error && <p className="text-red-400 text-sm" role="alert">{error}</p>}
              <button type="submit" disabled={loading} className="w-full bg-[#c9a84c] hover:bg-[#b8973f] text-[#0a1628] font-semibold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50" data-testid="forgot-submit">
                {loading ? <Loader2 size={16} className="animate-spin" /> : <Mail size={15} />}
                {loading ? 'Enviando…' : 'Enviar enlace'}
              </button>
            </form>
          )}
        </div>

        <p className="text-center mt-6">
          <Link to="/dashboard/login" className="inline-flex items-center gap-1.5 text-xs text-gray-400 hover:text-white">
            <ArrowLeft size={13} /> Volver al acceso
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
